import { render, staticRenderFns } from "./PlantBright.vue?vue&type=template&id=2749e922"
import script from "./PlantBright.vue?vue&type=script&lang=js"
export * from "./PlantBright.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports